import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { limitNumber } from '../../helpers';
import CartIcon from '@wix/da-ds/pkg/Icons/Cart';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
var CartLink = function (_a) {
    var cartCount = _a.cartCount, className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName;
    var t = useTranslation().t;
    return (React.createElement(BiLink, { biData: {
            evid: BiEventType.TOP_NAV_CLICK,
            link_url: URLS.CART,
            link_name: 'cart',
            indicator: cartCount,
        }, className: className, href: URLS.CART, "aria-label": t('siteHeader.a11y.cart.withItems', {
            formattedCount: limitNumber(cartCount),
        }) },
        React.createElement("span", null,
            React.createElement(CartIcon, { size: IconSize.MEDIUM, className: iconClassName }),
            React.createElement("span", { className: numberClassName }, limitNumber(cartCount)))));
};
CartLink.displayName = 'CartLink';
export default CartLink;
//# sourceMappingURL=CartLink.js.map